var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '../../../../styles/styled';
import { getSelectedChildIndex, getSecondaryChildren, getChildrenLength, } from '../../SidebarService';
const SUB_NAV_ITEM_HEIGHT = 32;
/* eslint-disable max-len */
const baseStyles = ({ theme }) => css `
  margin: -${theme.spacings.byte} 0 ${theme.spacings.byte} ${theme.spacings.tera};
  list-style: none;
  height: 0;
  position: absolute;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
`;
/* eslint-enable max-len */
const visibleStyles = ({ theme, visible, children, }) => visible &&
    css `
    height: calc(${SUB_NAV_ITEM_HEIGHT}px * ${getChildrenLength(children)});
    position: relative;
    opacity: 1;
    visibility: inherit;
    transition: height ${theme.transitions.default},
      opacity ${theme.transitions.default} 100ms,
      visibility ${theme.transitions.default} 100ms;
  `;
const listStyles = ({ theme, children }) => children &&
    css `
    &::before {
      content: '';
      width: 2px;
      background: ${theme.colors.n500};
      height: calc(${SUB_NAV_ITEM_HEIGHT}px * ${getChildrenLength(children)});
      position: absolute;
      top: 0;
      border-radius: 1px;
    }
  `;
const selectedItemStyles = ({ theme, selectedChildIndex, }) => selectedChildIndex &&
    selectedChildIndex >= 0 &&
    css `
    &::after {
      content: '';
      width: 2px;
      background: ${theme.colors.p500};
      height: ${SUB_NAV_ITEM_HEIGHT}px;
      border-radius: 1px;
      position: absolute;
      top: calc(${SUB_NAV_ITEM_HEIGHT}px * ${selectedChildIndex});
      transition: top ${theme.transitions.default};
    }
  `;
const SubNavigationContainer = styled.ul(baseStyles, selectedItemStyles, listStyles, visibleStyles);
export function SubNavList(_a) {
    var { children, visible = false } = _a, props = __rest(_a, ["children", "visible"]);
    return (_jsx(SubNavigationContainer, Object.assign({}, props, { visible: visible, selectedChildIndex: getSelectedChildIndex(children), 
        // @ts-expect-error Wontfix: this component is deprecated.
        // eslint-disable-next-line react/no-children-prop
        children: getSecondaryChildren(children, visible) })));
}
